import React from 'react';
import { Redirect } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'reactstrap';
import Loading from './Loading';
import { startSupportChat } from '../../utils/Api';

class SupportChatDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      id: 0,
      errorMessage: '',
      isLoaded: false,
    };
  }

  componentDidMount() {
    startSupportChat().then(({ id, error }) => {
      this.setState({
        ...(id ? { id } : { errorMessage: error && error.msg }),
        isLoaded: true,
      });
    });
  }

  render() {
    const { id, errorMessage, isLoaded } = this.state;
    if (id) {
      return <Redirect to={`/trainings/chats/${id}`} />;
    }

    return (
      <div style={{ position: 'relative' }}>
        {!isLoaded && <Loading />}
        {errorMessage && <Alert color="danger"><FormattedMessage id={errorMessage} /></Alert>}
      </div>
    );
  }
}

export default SupportChatDetails;



// WEBPACK FOOTER //
// ./src/views/_Chats/Support.js